import { InfoOutlineIcon } from '@carboncopyco/icons';
import {
  ColorHex,
  Paper,
  Separator,
  TextLargeParagraphTitle,
  Tooltip,
} from '@carboncopyco/ui';
import { useRef } from 'react';
import { SpeakerNotes, type SpeakerNotesProps } from './SpeakerNotes';

export const SpeakerNotesCard = (props: SpeakerNotesProps) => {
  const infoRef = useRef<HTMLDivElement>(null);

  return (
    <div className="h-full max-h-[800px]">
      <Paper
        radius
        border="ds-regular"
        fillParent
      >
        <div className="flex flex-col h-full">
          <div className="p-4">
            <div className="flex items-center gap-2 p-3">
              <TextLargeParagraphTitle
                color="text-ds-natural-700"
                label="Speaker notes"
              />
              <div ref={infoRef}>
                <InfoOutlineIcon
                  size={12}
                  color={ColorHex.natural300}
                />
              </div>
              <Tooltip
                placement="top"
                anchorRef={infoRef}
              >
                <div className="p-3">
                  Speaker notes are only
                  <br />
                  available for demos given
                  <br />
                  using the desktop app.
                </div>
              </Tooltip>
            </div>
          </div>
          <Separator horizontal />
          <div className="p-4 grow">
            <SpeakerNotes {...props} />
          </div>
        </div>
      </Paper>
    </div>
  );
};
